import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import {FlagService, DataService, AgeGroupService} from '@core/services';
import { faInfoCircle, faUserTag } from '@fortawesome/free-solid-svg-icons';
// import * as moment from 'moment';
import { merge, Observable, OperatorFunction, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { HIPInsuredPersonDto } from '../../../modules/_services/api/@generated/models';
import { GeneralUtils } from '@shared/utils';
import { EmployeeDataModel } from '@core/models/employee-data-model';
import moment from 'moment/moment';

@Component({
  selector: 'app-userdata-juncture',
  templateUrl: './userdata-juncture.component.html',
  styleUrls: ['./userdata-juncture.component.scss'],
  standalone: false
})
export class UserdataJunctureComponent implements OnInit, AfterViewInit {
  faInfoCircle = faInfoCircle;
  faUserTag = faUserTag;
  validationStarted = false;

  //for data reusage in insurantData
  insurantData = this.DropdownFrame.returnInsurantData();

  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  public birthDateInputError = false;
  public birthDateIsNotValid = false;

  continueNow = false;

  _currentYear = new Date().getFullYear();
  _birthYear = '';
  _birthMonth = '';
  _birthDay = '';

  _preNameInput = '';
  _surNameInput = '';
  _foreNameInput = '';
  _birthNameInput = '';
  _birthDateInput = '';
  _birthPlaceInput = '';
  _mothersNameInput = '';
  _legalRepNameInput = '';
  _forChildren = false;

  _sameAsBirthName = false;

  public employee: EmployeeDataModel;
  public sameAsEmployee = false;

  public focusTitle$ = new Subject<string>();

  searchTitle: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const inputFocus$ = this.focusTitle$;

    return merge(debouncedText$, inputFocus$).pipe(map(term => {
      const list = this.DataService.getTitleList().filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1);
      return (term.length < 1 || list.length < 1) ? this.DataService.getTitleList() : list.slice(0, 10);
    }));
  }

  private loadedData: HIPInsuredPersonDto = null;

  constructor(private DropdownFrame: DropdownFrameComponent, public DataService: DataService, public FlagService: FlagService,
              private ageGroupService: AgeGroupService,
              public generalUtils: GeneralUtils) { }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.DataService.fixInfoContainerHeight + 215 + (this.DataService.isPartneri() ? 65 : 0));
  }

  ngOnInit(): void {
//    for(let i = 0; i < 150; i++) {
//      this._availableYears[i] = this._currentYear - i;
//    }

    const savedBirthDate = sessionStorage.getItem('birthDay');
    if (savedBirthDate) {
      this._birthDateInput = savedBirthDate;
    }

    if(this.DataService.connectionLinkType === "PARTNERI") {
      this.continueNow = false;
      window.location.href.includes('&InterruptionId=')? this.continueNow = true : this.continueNow = false;
      sessionStorage.choosenOffer? this.continueNow = false : this.continueNow = true;
      //SET local for testing purposes
      //this.continueNow = false;
    } else {
      this.continueNow = true;
    }
    if (sessionStorage.getItem('HIPInsuredPersonFromHIPDto') && this._birthDateInput) {
      const hipData = JSON.parse(sessionStorage.getItem('HIPInsuredPersonFromHIPDto'));

      const riskStartDateYear: number = +(moment(hipData.riskStartDate).format('YYYY'));
      const birthDateYear: number = +(moment(this._birthDateInput).format('YYYY'));
      const age: number = riskStartDateYear - birthDateYear;

      this._forChildren = age < 18;
    }
    const person = sessionStorage.getItem('HIPInsuredPersonFromHIPDto');
    if (person) {
      const personObj = JSON.parse(person);
      if (personObj.insuredPerson) {
        this.loadDataFromSessionStorage(personObj.insuredPerson);
      }
      if (personObj.employee) {
        this.employee = personObj.employee;
      }
    }
  }

  public contractIsOKToContinue(): boolean {
    const dto = sessionStorage.getItem('HIPInsuredPersonFromHIPDto');
    if (!dto) {
      return false;
    }

    const obj = JSON.parse(dto);
    return obj && obj.koopFrameContractId === '55349875';
  }

  private loadDataFromSessionStorage(data: HIPInsuredPersonDto): void {
    this.loadedData = data;
    this._preNameInput = data.title;
    this._foreNameInput = data.firstName;
    this._surNameInput = data.lastName;
    this._birthNameInput = data.birthName;

    const birthDate = data.birthDate.split('-');
    this._birthYear = birthDate[0];
    this._birthMonth = birthDate[1];
    this._birthDay = birthDate[2];
    this._birthDateInput = data.birthDate;

    this._birthPlaceInput = data.birthPlace;
    this._mothersNameInput = data.mothersName;
  }

//  birthInputChange() {
//    if (this._birthYear && this._birthMonth && this._birthDay) {
//      this._birthDateInput = this._birthYear + '-' + this._birthMonth + '-' + this._birthDay;
//    } else {
//      this._birthDateInput = '';
//    }
//    this.birthDayIsOK(this._birthDateInput);
//  }

  sameAsBirthName() {
    if(this._sameAsBirthName) {
      this._birthNameInput = this._surNameInput + ' ' + this._foreNameInput;
    }
  }

  public nameChanged(): void {
    this.sameAsBirthName();
    if (!this.DataService.isPartneri()) {
      // HOZZATARTOZOI || KOMPAKT_HOZZATARTOZOI
      this.checkEmployeeNameAndBirthdate();
    }
  }

  private checkEmployeeNameAndBirthdate(): void {
    this.sameAsEmployee =
      this.employee.birthDate === this._birthDateInput &&
      this.employee.name.replace(/ /g, '') === (this._surNameInput + this._foreNameInput).replace(/ /g, '');
  }

//  private birthDayIsOK(bDay: string): void {
//    if (bDay.length !== 10) {
//      return;
//    }
//
//    this.birthDateIsNotValid = moment(bDay, 'YYYY-MM-DD').format('YYYY-MM-DD') !== bDay;
//    if (this.birthDateIsNotValid) {
//      return;
//    }
//
//    let minAge;
//    let maxAge;
//
//    if (this.DataService.isKompakt()) {
//      minAge = moment(bDay, 'YYYY-MM-DD').add(this.ageGroupService.choosenAgeGroup[0].ages.kompakt_min, 'months');
//      maxAge = moment(bDay, 'YYYY-MM-DD').add(this.ageGroupService.choosenAgeGroup[0].ages.kompakt_max, 'months');
//    } else {
//      minAge = moment(bDay, 'YYYY-MM-DD').add(this.ageGroupService.choosenAgeGroup[0].ages.min, 'months');
//      maxAge = moment(bDay, 'YYYY-MM-DD').add(this.ageGroupService.choosenAgeGroup[0].ages.max, 'months');
//    }
//
//    const bDayOK = minAge < moment() && moment() < maxAge;
//    this.birthDateInputError = !bDayOK;
//  }

  sendUserdata() {
    if (this.sameAsEmployee) {
      return;
    }

    this.validationStarted = true;

    if (this._surNameInput === '' || this._foreNameInput === '' || this._birthNameInput === '' ||
//      this._birthYear === '' || this._birthMonth === '' || this._birthDay === '' || this.birthDateIsNotValid || this.birthDateInputError ||
      this._birthDateInput === '' || this._birthPlaceInput === '' || this._mothersNameInput === '' ||
      (this._legalRepNameInput === '' && this._forChildren) || !this.checkTitle()) {
        return;
    }

    const insuredPerson = {
      title: this._preNameInput,
      firstName: this._foreNameInput,
      lastName: this._surNameInput,
      birthName: this._birthNameInput,
      birthDate: this._birthDateInput,
      birthPlace: this._birthPlaceInput,
      mothersName: this._mothersNameInput,

//      addressZip: null,
//      addressState: null,
//      addressCity: null,
//      addressStreet: null,
//      addressHouseNr: null,
//      postalAddressZip: null,
//      postalAddressState: null,
//      postalAddressCity: null,
//      postalAddressStreet: null,
//      postalAddressHouseNr: null,
//      mobileNumber: null,
//      email: null,
//
//      socialSecurityNumber: null,
//      passport: null,
//      taxNumber: null
    };

//    if(this.DataService.HIPInsuredPersonFromHIPDto.insuredPerson) {
//      this.DataService.HIPInsuredPersonFromHIPDto.insuredPerson.email? insuredPerson.email = this.DataService.HIPInsuredPersonFromHIPDto.insuredPerson.email : null;
//    }

    const person2save = {...this.loadedData, ...insuredPerson};

    //if validation is good
    if(true) this.userdataJunctureClick();
    this.newInsurantDataLocation.emit('insuredPerson');
    this.newInsurantDataEvent.emit({ insuredPerson: person2save, legalGuardian: this._legalRepNameInput });
  }

  userdataJunctureClick() {
    if (this.DataService.connectionLinkType === 'HOZZATARTOZOI' || this.DataService.connectionLinkType === 'PARTNERI') {
      this.DropdownFrame.junctureClick('socsecurityJunctureFlag', 4);
    }
    else{
      this.FlagService.flagServiceObject[4]['socsecurityJunctureFlag'] = true;
      this.DropdownFrame.junctureClick('contactinfoJunctureFlag', 5);
    }
  }

  public checkTitle(): boolean {
    return this._preNameInput === '' ||
      this.DataService.getTitleList().some((item) => item === this._preNameInput);
  }
}
